/** LazyStudio brand images (src/assets/logos). */
import logo from "../../assets/logos/logo-white.png";
import favicon from "../../assets/logos/favicon-white.png";

export const BRAND_NAME = "LazyStudio.Ai";

export const BRAND_LOGO = {
  sidebar: logo,
  favicon,
};

export const SOCIAL_LINKS = {
  x: "https://x.com/Lazy_Studio_ai",
  instagram:
    "https://www.instagram.com/lazystudio.ai?igsh=djhyaGQwaGdiazU3&utm_source=qr",
  youtube: "https://www.youtube.com/@lazystudio_ai",
};
